"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DistrictReporting = void 0;
const obejct_diff_1 = require("../utils/obejct-diff");
// export class ReportingContext {
//     // speciesToReport: string[]|undefined  
//     identifier: string
//     creationDate: Date|undefined
//     updateTimestamp: Date|undefined
//     constructor(
//         public reportingContextId: string,  // also identifier of doc
//         public huntingDistrictName: string, 
//     ) {
//         this.identifier = reportingContextId
//     }
//     setFromAny(element: any) {
//         // Object.assign(this, element)
//         const {
//             creationDate,
//             updateTimestamp
//         } = element
//         this.creationDate = creationDate ? isDate(creationDate) ? creationDate : firestoreTimestampToDate(creationDate) : this.creationDate
//         this.updateTimestamp = updateTimestamp ? isDate(updateTimestamp) ? updateTimestamp : firestoreTimestampToDate(updateTimestamp) : this.updateTimestamp
//     }
// }
class DistrictReporting {
    constructor(contextId, reportingContextId, reportingContextName, huntingDistrictId, huntingDistrictName, reportingImages = false, reportingPlaceOfKilling = false, huntingDistrictAdministrativeName, speciesToReport, reportingEmails, reportingEmailTemplate) {
        this.contextId = contextId;
        this.reportingContextId = reportingContextId;
        this.reportingContextName = reportingContextName;
        this.huntingDistrictId = huntingDistrictId;
        this.huntingDistrictName = huntingDistrictName;
        this.reportingImages = reportingImages;
        this.reportingPlaceOfKilling = reportingPlaceOfKilling;
        this.huntingDistrictAdministrativeName = huntingDistrictAdministrativeName;
        this.speciesToReport = speciesToReport;
        this.reportingEmails = reportingEmails;
        this.reportingEmailTemplate = reportingEmailTemplate;
    }
    setFromAny(element) {
        const { identifier, creationDate, updateTimestamp } = element;
        this.identifier = identifier ? identifier : this.identifier;
        this.creationDate = creationDate ? (0, obejct_diff_1.isDate)(creationDate) ? creationDate : (0, obejct_diff_1.firestoreTimestampToDate)(creationDate) : this.creationDate;
        this.updateTimestamp = updateTimestamp ? (0, obejct_diff_1.isDate)(updateTimestamp) ? updateTimestamp : (0, obejct_diff_1.firestoreTimestampToDate)(updateTimestamp) : this.updateTimestamp;
    }
    searchFilter(filter) {
        const str = `${this.identifier}${this.huntingDistrictName}${this.reportingContextName}`.toLowerCase();
        return str.includes(filter);
    }
}
exports.DistrictReporting = DistrictReporting;
